export default __webpack_public_path__ + "static/media/ribbon-max-value.7bbcfdc4.png";